import { TranslationState } from '@blk/cwp-ng-framework';
import { StringValue } from '@blk/simba';
import * as isUndefined from 'lodash/isUndefined';

import { CellAttributes } from './cell-attributes';
import { ColumnConfig } from './column-config';
import { ColumnExtractor } from './extractors/column-extractor';

export class CellData implements StringValue {
	public formattedValue: string;
	public valueTranslation?: TranslationState;

	public static create(options: CellDataOptions): CellData {
		return new CellData(options.config, options.rawValue, options.formattedValue, options.parent, options.attribute, options.children);
	}
	constructor(
		public readonly config: ColumnConfig<ColumnExtractor>,
		public rawValue: string | number | Array<any> | boolean,
		formattedValue?: string | TranslationState,
		public readonly parent?: CellData[],
		public attribute: CellAttributes = {},
		public readonly children?: CellData[]
	) {
		if (formattedValue instanceof TranslationState) {
			this.formattedValue = formattedValue.toString();
			this.valueTranslation = formattedValue;
		} else {
			this.formattedValue = formattedValue;
		}
		if (this.rawValue !== null && !isUndefined(this.rawValue) && isUndefined(formattedValue)) {
			// Set default formatted value
			this.formattedValue = this.rawValue.toString();
		}
	}

	public toString(): string {
		return this.formattedValue;
	}
}

export interface CellDataOptions {
	config: ColumnConfig<ColumnExtractor>;
	rawValue: string | number | Array<any> | boolean;
	formattedValue?: string | TranslationState;
	parent?: CellData[];
	attribute: CellAttributes;
	children?: CellData[];
}
